// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDHlMq1bO_3Nz7iu3aPQTCr4Y07grFfDxk",
  authDomain: "JourneWebsite.firebaseapp.com",
  projectId: "journewebsite",
  storageBucket: "journewebsite.firebasestorage.app",
  messagingSenderId: "451247483369",
  appId: "1:451247483369:web:76ee2cbd3bdc50fdc0c378",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, auth, storage };